interface Feature {
  icon: string;
  title: string;
  desc: string;
}

const features: Feature[] = [
  {
    icon: 'ri-speed-up-line',
    title: '全网最快速递',
    desc: '24小时滚动更新机制，全天候追踪娱乐圈最新动态。编辑团队覆盖早中晚三班，确保第一时间推送到您面前。',
  },
  {
    icon: 'ri-verified-badge-line',
    title: '三重核实机制',
    desc: '每一条爆料均经过信源核实、多方交叉验证和编辑审核三道关卡，准确率高达99.7%，拒绝传播虚假信息。',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: '安全加密访问',
    desc: '全站HTTPS加密传输，定期更新安全入口地址。通过本站提供的官方入口访问，远离钓鱼网站和恶意软件威胁。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量内容聚合',
    desc: '覆盖明星恋情、综艺内幕、带货翻车、法制事件、韩娱日娱等全品类吃瓜内容，一站式满足您的八卦需求。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '瓜友社区互动',
    desc: '百万活跃瓜友共建的吃瓜社区，理性讨论氛围浓厚。每日大赛排名由社区热度决定，人人都是吃瓜裁判。',
  },
];

const SectionFeatures = () => (
  <section id="features" className="py-16 md:py-20 bg-background-50">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">平台特色</h2>
        <p className="mt-2 text-sm text-foreground-500">为什么百万瓜友选择吃瓜网每日大赛</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
        {features.map((f) => (
          <div key={f.title} className="group p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all text-center cursor-pointer">
            <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors mx-auto">
              <i className={`${f.icon} text-xl`}></i>
            </span>
            <h3 className="mt-4 text-sm font-semibold text-foreground-900">{f.title}</h3>
            <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SectionFeatures;